module.exports = __webpack_public_path__ + "static/media/hot_water.035b4ee1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/amenities/hot_water.svg
// module id = 558
// module chunks = 0